import React, {useEffect,useState} from 'react';
import {FormValidator, useFormValidator, Inputs, TextArea} from 'coaz-ui';
import client from '../client';
import { toFormData } from "axios";

const AddFile = ({ params, submitRef, setLoading, setEnableSubmit }) => {
	const topicId = params ? params.topicId : null;
	const cpdId = params ? params.cpdId : null;
	const [user, setUser] = useState(null);
	const [fileResource, setFileResource] = useState(null);
	const [durationUnits, setDurationUnits] = useState([]);
	const minWidth = 240;
	const { request, sendFormData, getCurrent, errorMessage } = client;

	const submit = async (e) => {
		if (!user || !fileResource)
			return {
				message: " missing fields!",
			};

		try {
			console.log(fileResource);
			const formatDate = toFormData(fileResource, new FormData(),{dots: true});

			const response = await sendFormData(
				"POST",
				"file-resources",
				formatDate,
			);

			if (response) {
				return {
					message: "Successful",
					success: true,
				};
			}

			return {
				message: errorMessage(response),
			};
		} catch (error) {
			console.log(error.response && error.response.data);
			return {
				message: errorMessage(error),
			};
		}
	};

	const [register, handleChange, handleSubmit, errors] =
		useFormValidator(submit);

	const onChange = (e) => {
		const { name, value, files, type } = e.target;

		setFileResource((prev) => ({
			...prev,
			[name]: type === "file" ? files[0] : value,
		}));
	};

	const onNumber = (e) => {
		const { name, value } = e.target;

        if (isNaN(value)) return;

		setFileResource((prev) => ({
			...prev,
			[name] : value,
		}));
    };

	const inputs = [
		{
			label: "Name",
			type: "text",
			name: "name",
			value: fileResource?.name ?? "",
			placeholder: "Enter name...",
			onChange: (e) => handleChange(e, onChange),
			register: register,
			checks: ["empty"],
			errors: errors,
		},
		{
			label: "DurationUnit",
			type: "select",
			options: () => {
				let options = [];
				durationUnits &&
					durationUnits.map((option, i) =>
						options.push(
							<option key={i} value={option}>
								{option}
							</option>,
						),
					);
				return options;
			},
			name: "durationUnit",
			value: fileResource?.durationUnit ?? "",
			onChange: (e) => handleChange(e, onChange),
			register: register,
			checks: ["empty"],
			errors: errors,
		},
		{
            label:'Duration',
            type:'number', 
            name:'duration',
            value:fileResource?.duration ?? 0,   
            placeholder:'Select or enter points...',
            onChange:(e) => {handleChange(e,onNumber)}
        },
		{
            label:'File',
            type:'file', 
            name:'file',
            accept:'.pdf',   
            placeholder:'File...',
            onChange:(e) => {handleChange(e,onChange)},
            register:register,
            checks:['empty'],
            errors:errors
        }
	];

	useEffect(() => {
		if (handleSubmit) {
			submitRef.current = { submit: handleSubmit };
			setEnableSubmit(true);
		} else {
			submitRef.current = null;
			setEnableSubmit(false);
		}

		return () => {
			submitRef.current = null;
		};
	}, [handleSubmit]);

	useEffect(() => {
		(async () => {
			setLoading && setLoading(true);

			let current = null;

			try {
				current = await getCurrent();
			} catch (error) {
				console.log(error);
				return;
			}

			if (!current && !current.user) return;

			setUser(current.user);

			let resource = { teacherReference:current.user.ref.value};

			try {
				const response = await request("GET", `topics/${topicId}`);
				if (response && response.ref) {
					resource.topicId = response.ref.id;
				}
			} catch (error) {
				console.log(error);
			}

			try {
				const response = await request("GET", "duration-units");
				if (response && response.length > 0) {
					setDurationUnits(response);
					resource.durationUnit = response[0];
				} else {
					setDurationUnits([]);
				}
			} catch (error) {
				console.log(error);
			}

			setFileResource(resource);

			setLoading && setLoading(false);
		})();
	}, [cpdId]);

	return (
		<FormValidator>
			<Inputs
				inputs={inputs}
				minWidth={minWidth}
				onSubmit={handleSubmit}
			/>
		</FormValidator>
	);
};

export default AddFile;
